// Main application entry point
// This file controls the exact order of execution

// 3. Then: UI snippet components used across site
import './snippets/blocks.js';
import './utils/slider.js';
import './snippets/nav-main.js';
import './snippets/page-list-controls.js';
import './snippets/add-to-collection.js';